export const STRINGS = {
	en: {
		launcher: "Chat with support", close: "Minimise chat", online: "We're online", offline: "We're offline",
		online_hint: "Usually replies within a few minutes", name: "Your name", email: "Email", phone: "Phone",
		optional: "optional", message: "How can we help?", start: "Start chat", send: "Send", type: "Type a message…",
		whatsapp: "Chat on WhatsApp", or: "or", end: "End chat", end_confirm: "End this chat?", yes: "End chat",
		no: "Keep chatting", ended: "This chat has ended", rate: "How was your chat?", thanks: "Thanks for the feedback",
		new_chat: "Start a new chat", login: "Log in to chat with our team", login_btn: "Log in", sending: "Sending…",
		failed: "Not sent. Tap to retry.", network: "Can't reach the server. Check your connection.",
		you: "You", support: "Support", attach: "Attach a file", expired: "This chat is no longer available.",
		email_hint: "We'll email you if you leave before we reply.", unread: "new messages",
		ai_badge: "AI", bot_badge: "Bot", assistant: "Assistant", talk_person: "Talk to a person",
		waiting_agent: "Waiting for a member of our team. You can keep typing.",
		waiting_offline: "Our team is offline. We'll reply here and by email when we're back.",
		with_agent: "You're chatting with {0}", typing: "{0} is typing…", seen: "Seen", sources: "Sources",
		helpful: "Helpful", not_helpful: "Not helpful", thanks_fb: "Thanks for the feedback",
	},
	ar: {
		launcher: "تحدث مع الدعم", close: "تصغير المحادثة", online: "نحن متصلون", offline: "نحن غير متصلين الآن",
		online_hint: "نرد عادةً خلال دقائق", name: "اسمك", email: "البريد الإلكتروني", phone: "رقم الهاتف",
		optional: "اختياري", message: "كيف يمكننا مساعدتك؟", start: "ابدأ المحادثة", send: "إرسال", type: "اكتب رسالة…",
		whatsapp: "تواصل عبر واتساب", or: "أو", end: "إنهاء المحادثة", end_confirm: "هل تريد إنهاء هذه المحادثة؟",
		yes: "إنهاء", no: "متابعة", ended: "انتهت هذه المحادثة", rate: "كيف كانت المحادثة؟", thanks: "شكراً على تقييمك",
		new_chat: "ابدأ محادثة جديدة", login: "سجّل الدخول للتحدث مع فريقنا", login_btn: "تسجيل الدخول",
		sending: "جارٍ الإرسال…", failed: "لم تُرسل. اضغط لإعادة المحاولة.", network: "تعذر الاتصال بالخادم.",
		you: "أنت", support: "الدعم", attach: "إرفاق ملف", expired: "هذه المحادثة لم تعد متاحة.",
		email_hint: "سنراسلك عبر البريد إذا غادرت قبل ردنا.", unread: "رسائل جديدة",
		ai_badge: "ذكاء اصطناعي", bot_badge: "روبوت", assistant: "المساعد", talk_person: "التحدث مع موظف",
		waiting_agent: "بانتظار أحد أعضاء فريقنا. يمكنك متابعة الكتابة.",
		waiting_offline: "فريقنا غير متصل الآن. سنرد هنا وعبر البريد عند عودتنا.",
		with_agent: "أنت تتحدث مع {0}", typing: "{0} يكتب…", seen: "تمت المشاهدة", sources: "المصادر",
		helpful: "مفيد", not_helpful: "غير مفيد", thanks_fb: "شكراً على تقييمك",
	},
};
